import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();
  const [openSection, setOpenSection] = useState(null);

  const footerLinks = {
    company: [
      { label: "Email: Draggintrailers@gmail.com", path: "mailto:Draggintrailers@gmail.com", isEmail: true }
    ],
    ownersRenters: [
      { label: "Payouts", path: "/payout-management" },
      { label: "Disputes", path: "/dispute-resolution" },
      { label: "Charge Disputes", path: "/charge-dispute" }
    ],
    legal: [
      { label: "Terms of Service", path: "/terms-of-service" },
      { label: "Privacy Policy", path: "/privacy-policy" },
      { label: "Cookie Policy", path: "/cookie-policy" },
      { label: "State Towing Regulations", path: "/state-towing-regulations" }
    ]
  };

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <footer className="bg-secondary text-secondary-foreground pt-12 md:pt-16 lg:pt-20 pb-6 md:pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Logo and Social - Always Visible */}
        <div className="mb-6 md:mb-0">
          <Link to="/home-page" className="flex items-center space-x-3 mb-4">
            <img 
              src="/assets/images/ChatGPT_Image_Feb_3_2026_04_58_59_PM-1770675660365.png" 
              alt="Draggin Trailers Logo" 
              className="w-10 h-10 md:w-12 md:h-12 object-contain rounded-md"
            />
            <span className="font-heading font-bold text-lg md:text-xl">
              Draggin Trailers
            </span>
          </Link>
          <p className="font-body text-sm text-secondary-foreground/70 mb-4">
            The peer-to-peer trailer rental marketplace connecting owners and renters nationwide.
          </p>
        </div>

        {/* Mobile Accordion / Desktop Grid */}
        <div className="mt-8 md:mt-12">
          {/* Mobile: Single Column Accordion */}
          <div className="md:hidden space-y-2">
            {/* Company Section */}
            <div className="border-b border-secondary-foreground/10">
              <button
                onClick={() => toggleSection('company')}
                className="w-full flex items-center justify-between py-4 min-h-[44px] touch-manipulation"
                aria-expanded={openSection === 'company'}
              >
                <h4 className="font-heading font-semibold text-base">Company</h4>
                <Icon 
                  name="ChevronDown" 
                  size={20} 
                  className={`transition-transform duration-300 ${openSection === 'company' ? 'rotate-180' : ''}`}
                />
              </button>
              <div 
                className={`overflow-hidden transition-all duration-300 ${openSection === 'company' ? 'max-h-96 pb-4' : 'max-h-0'}`}
              >
                <ul className="space-y-1">
                  {footerLinks?.company?.map((link, index) => (
                    <li key={index}>
                      {link?.isEmail ? (
                        <a
                          href={link?.path}
                          className="block font-body text-sm text-secondary-foreground/70 hover:text-primary transition-smooth py-2 min-h-[44px] flex items-center touch-manipulation"
                        >
                          {link?.label}
                        </a>
                      ) : (
                        <Link
                          to={link?.path}
                          className="block font-body text-sm text-secondary-foreground/70 hover:text-primary transition-smooth py-2 min-h-[44px] flex items-center touch-manipulation"
                        >
                          {link?.label}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Owners/Renters Section */}
            <div className="border-b border-secondary-foreground/10">
              <button
                onClick={() => toggleSection('ownersRenters')}
                className="w-full flex items-center justify-between py-4 min-h-[44px] touch-manipulation"
                aria-expanded={openSection === 'ownersRenters'}
              >
                <h4 className="font-heading font-semibold text-base">Owners/Renters</h4>
                <Icon 
                  name="ChevronDown" 
                  size={20} 
                  className={`transition-transform duration-300 ${openSection === 'ownersRenters' ? 'rotate-180' : ''}`}
                />
              </button>
              <div 
                className={`overflow-hidden transition-all duration-300 ${openSection === 'ownersRenters' ? 'max-h-96 pb-4' : 'max-h-0'}`}
              >
                <ul className="space-y-1">
                  {footerLinks?.ownersRenters?.map((link, index) => (
                    <li key={index}>
                      <Link
                        to={link?.path}
                        className="block font-body text-sm text-secondary-foreground/70 hover:text-primary transition-smooth py-2 min-h-[44px] flex items-center touch-manipulation"
                      >
                        {link?.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Legal Section */}
            <div className="border-b border-secondary-foreground/10">
              <button
                onClick={() => toggleSection('legal')}
                className="w-full flex items-center justify-between py-4 min-h-[44px] touch-manipulation"
                aria-expanded={openSection === 'legal'}
              >
                <h4 className="font-heading font-semibold text-base">Legal</h4>
                <Icon 
                  name="ChevronDown" 
                  size={20} 
                  className={`transition-transform duration-300 ${openSection === 'legal' ? 'rotate-180' : ''}`}
                />
              </button>
              <div 
                className={`overflow-hidden transition-all duration-300 ${openSection === 'legal' ? 'max-h-96 pb-4' : 'max-h-0'}`}
              >
                <ul className="space-y-1">
                  {footerLinks?.legal?.map((link, index) => (
                    <li key={index}>
                      <Link
                        to={link?.path}
                        className="block font-body text-sm text-secondary-foreground/70 hover:text-primary transition-smooth py-2 min-h-[44px] flex items-center touch-manipulation"
                      >
                        {link?.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Desktop: Grid Layout */}
          <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
            <div>
              <h4 className="font-heading font-semibold text-base md:text-lg mb-4">Company</h4>
              <ul className="space-y-2">
                {footerLinks?.company?.map((link, index) => (
                  <li key={index}>
                    {link?.isEmail ? (
                      <a
                        href={link?.path}
                        className="font-body text-sm text-secondary-foreground/70 hover:text-primary transition-smooth"
                      >
                        {link?.label}
                      </a>
                    ) : (
                      <Link
                        to={link?.path}
                        className="font-body text-sm text-secondary-foreground/70 hover:text-primary transition-smooth"
                      >
                        {link?.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-base md:text-lg mb-4">Owners/Renters</h4>
              <ul className="space-y-2">
                {footerLinks?.ownersRenters?.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={link?.path}
                      className="font-body text-sm text-secondary-foreground/70 hover:text-primary transition-smooth"
                    >
                      {link?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-base md:text-lg mb-4">Legal</h4>
              <ul className="space-y-2">
                {footerLinks?.legal?.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={link?.path}
                      className="font-body text-sm text-secondary-foreground/70 hover:text-primary transition-smooth"
                    >
                      {link?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="pt-6 md:pt-8 mt-6 md:mt-8 border-t border-secondary-foreground/10">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="font-caption text-xs md:text-sm text-secondary-foreground/60 text-center md:text-left">
              &copy; {currentYear} Draggin Trailers. All rights reserved.
            </p>

            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <Icon name="Shield" size={16} color="var(--color-success)" strokeWidth={2} />
                <span className="font-caption text-xs text-secondary-foreground/60">SSL Secured</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Lock" size={16} color="var(--color-success)" strokeWidth={2} />
                <span className="font-caption text-xs text-secondary-foreground/60">Encrypted</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;